module.exports = __webpack_public_path__ + "static/media/themplane3.eec2dab9.webp";